import {useQuery, useMutation} from "@tanstack/react-query";
import {API} from "api";

export const useUserRoles = () => {
  const {
    data: users = [],
    isLoading: loading,
    error: queryError,
    refetch: fetchUsers,
  } = useQuery({
    queryKey: ["user-roles"],
    queryFn: API.fetchUserRoles,
  });

  const error = queryError ? "Failed to load user roles" : null;

  return {users, loading, error, fetchUsers};
};

export const useUpdateUserRoleMutation = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (params) => {
      const {email, role} = params;
      return API.updateUserRole(email, role);
    },
    onSuccess,
    onError: (err) => {
      if (onError) {
        onError(err);
      }
      console.error(err);
    },
  });
};

export const useDeleteUserRoleMutation = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (email) => API.deleteUserRole(email),
    onSuccess,
    onError: (err) => {
      if (onError) {
        onError(err);
      }
      console.error(err);
    },
  });
};
